module.exports = __webpack_public_path__ + "9ea69d7c2397c038.svg";